/**
 * Constructor de gráficas del home.
 *
 * Cada widget se monta por LAZY IMPORT desde su ruta en el catálogo
 * (CIMS0036.GRARUTAX) — el mismo patrón de Mi Puesto con PESTCOMX. Antes
 * había un mapa estático de imports (Graphsel) y registrar un widget
 * exigía tocar código y recompilar; ahora registrar un widget es un
 * INSERT en la parametría (FASE 5, root/cimaapi#355).
 */
import { Suspense, lazy, useMemo } from "react";

export function Bugraphs({ graphs }) {
  const getGraphKeyName = (graphName) => {
    if (graphName) {
      return graphName.toLowerCase().split(" ").join("-");
    }
    return "";
  };

  const converFristUppercase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  //Ruta del componente: la del catálogo, o la convención histórica de la
  //carpeta de gráficas para filas viejas sin ruta parametrizada.
  const rutaDe = (graph) =>
    graph?.GRARUTAX || `Builders/Bugrafx/Graphics/${converFristUppercase(graph?.GRACOMXX ?? "")}`;

  const componentes = useMemo(
    () =>
      (graphs ?? []).map((graph) => ({
        graph,
        Componente: lazy(() =>
          import(`../../${rutaDe(graph)}`).catch((error) => {
            console.error("Bugraphs: widget no cargó:", rutaDe(graph), error);
            return { default: () => null };
          })
        ),
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [graphs]
  );

  return (
    <>
      {componentes.map(({ graph, Componente }, keyGraph) => (
        <Suspense key={`${graph?.GRACOMXX}-${keyGraph}`} fallback={null}>
          <Componente
            graphName={graph?.GRANOMXX}
            MODIDXXX={107}
            PROIDXXX={101}
            graphKeyName={getGraphKeyName(graph?.GRANOMXX)}
          />
        </Suspense>
      ))}
    </>
  );
}
